import { api, startLoading, endLoading } from '@/api'
import * as types from './types'

export default {
  /**
  * Reset location values to its defaults
  */
  resetGroupValues ({ commit }) {
    commit(types.RESET_GROUP)
  },
  /**
  * Get group by id
  * @param {Number} groupID - Group ID
  */
  async getGroup ({ commit, dispatch }, groupID) {
    let loaderName = 'getGroup'
    startLoading(dispatch, loaderName)
    return new Promise((resolve, reject) => {
      api
        .getGroup(groupID)
        .then((response) => {
          commit(types.SET_GROUP, response.data)
          endLoading(dispatch, loaderName)
          resolve(response.data)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Get all groups by based on location
  * @param {Object} params - Use to send either a SearchOptions object or LocationID
  */
  async getGroupsByLocation ({ commit, dispatch }, params) {
    let loaderName = 'getGroupsByLocation'
    startLoading(dispatch, loaderName)

    // Note: We are reusing this action to populate tables AND dropdowns.
    // Below, we check if the parameter sent was a number, meaning that a locationID was sent over.
    let locationID = null
    if (typeof params === 'number') {
      locationID = params
      params = null
    }

    // Call API
    return new Promise((resolve, reject) => {
      api
        .getGroupsByLocation(params, locationID)
        .then((response) => {
          commit(types.SET_GROUPS, response.data.items)
          endLoading(dispatch, loaderName)
          resolve(response.data.count)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Create new group
  */
  async createGroup ({ commit, dispatch, state }) {
    let loaderName = 'createGroup'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .createGroup(state.group)
        .then((response) => {
          // Note: If there's no data, it means that the location already exists
          if (response.data !== '') {
            commit(types.ADD_GROUP, response.data)
            resolve(response)
          } else {
            reject(new Error('Group already exists.'))
          }
          endLoading(dispatch, loaderName)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Update existing group
  */
  async updateGroup ({ commit, dispatch, state }) {
    let loaderName = 'updateGroup'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .updateGroup(state.group)
        .then((response) => {
          if (response.data === -1) {
            reject(new Error('Group name already exists.'))
          }
          resolve(response)
          endLoading(dispatch, loaderName)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Delete existing group
  */
  async deleteGroup ({ commit, dispatch }, group) {
    let loaderName = 'deleteGroup'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .deleteGroup({ id: group.id })
        .then((response) => {
          commit(types.DELETE_GROUP, group)
          endLoading(dispatch, loaderName)
          resolve(response)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  },
  /**
  * Get Top 5 buildings by group (Used for charts)
  * @param {Number} groupId - Group ID
  */
  async getTop5Buildings ({ commit, dispatch }, groupId) {
    let loaderName = 'getTop5Buildings'
    startLoading(dispatch, loaderName)

    return new Promise((resolve, reject) => {
      api
        .getTop5Buildings(groupId)
        .then((response) => {
          endLoading(dispatch, loaderName)
          resolve(response.data)
        })
        .catch((error) => {
          endLoading(dispatch, loaderName)
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/group/actions.js